module.exports = __webpack_public_path__ + "static/media/dotnet.ed5a0b2b.png";